import { functions, firestore } from "./firebase/firebaseInit";
import { collection, getDocs, orderBy, query } from "@firebase/firestore";
import { httpsCallable } from "@firebase/functions";

// Contato compartilhado por empresa (companies/{companyId}/sharedContacts)
// — mesmo padrão de services/userContacts.js, separado dele de propósito
// (dono único vs. compartilhado são modelos de permissão diferentes).

export const getAllSharedContacts = async (auth) => {
    const companyId = auth.user.token.claims.company;

    const q = query(
        collection(firestore, `companies/${companyId}/sharedContacts`),
        orderBy("name")
    );

    const snap = await getDocs(q);

    return snap.docs.reduce((prev, curr) => {
        return [...prev, { id: curr.id, ...curr.data(), doc: curr }];
    }, []);
};

export const createSharedContact = async (contactData) => {
    const create = httpsCallable(functions, "createSharedContact");
    return await create(contactData);
};

export const updateSharedContact = async (contactData) => {
    const update = httpsCallable(functions, "updateSharedContact");
    return await update(contactData);
};

export const deleteSharedContact = async (contactId) => {
    const del = httpsCallable(functions, "deleteSharedContact");
    return await del({ id: contactId });
};
